import type { ActivatedDrawId } from '../../../../schema/marketplace/entry.js';
import type { IGetRetailerBalanceUseCase, IMarketplaceGroupsService } from '../../../domain/entry.js';

type GetRetailerBalanceUseCaseParams = {
  activatedDrawId: ActivatedDrawId;
};

/**
 * Creates a use case for retrieving retailer balance.
 *
 * @param marketplaceGroupsService - The service used to fetch retailer balance
 * @returns A use case object with an execute method for getting retailer balance
 */
export function getRetailerBalanceUseCase(
  marketplaceGroupsService: IMarketplaceGroupsService
): IGetRetailerBalanceUseCase {
  return {
    execute: async ({
      activatedDrawId,
    }: GetRetailerBalanceUseCaseParams): ReturnType<IGetRetailerBalanceUseCase['execute']> => {
      const response = await marketplaceGroupsService.getRetailerBalanceAsync({ activatedDrawId });

      return response;
    },
  };
}
